import PropTypes from "prop-types"


const properties = {
  audience: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  createdBy: PropTypes.string,
  email: PropTypes.string,
  id: PropTypes.string.isRequired,
  ipAddress: PropTypes.string,
  jti: PropTypes.string.isRequired,
  keyId: PropTypes.string.isRequired,
  reason: PropTypes.string,
  status: PropTypes.string.isRequired,
  subject: PropTypes.string,
  updatedAt: PropTypes.string,
  updatedBy: PropTypes.string
}

const IndexOrganizationPublicKeyAuthenticationsOutputShapeShape = PropTypes.exact(properties)

export default IndexOrganizationPublicKeyAuthenticationsOutputShapeShape
export { properties }
